export const parseError = (err, def: string) =>
    (err?.data?.errors?.length && err?.data?.errors[0]?.message) || def;
